import React from 'react';
import MotorCurrencySelect from './MotorCurrencySelect';

const DikeySettings = React.memo(({
  activeTypeTab,
  dikeyExtras,
  setDikeyExtras,
  dikeyPvcExtras,
  setDikeyPvcExtras,
  dikeyStorExtras,
  setDikeyStorExtras,
  isFonListCollapsed,
  setIsFonListCollapsed,
  newDikeyFonName,
  setNewDikeyFonName,
  editingDikeyFonName,
  setEditingDikeyFonName,
  handleSaveSettings
}) => {
  const isPerde = activeTypeTab === 'dikeyPerde';
  const tabLabel = activeTypeTab === 'dikeyPerde' ? 'Dikey Perde' : activeTypeTab === 'dikeyPvc' ? 'Dikey PVC' : 'Dikey Stor';

  const extras = isPerde ? dikeyExtras : activeTypeTab === 'dikeyPvc' ? dikeyPvcExtras : dikeyStorExtras;
  const setExtras = isPerde ? setDikeyExtras : activeTypeTab === 'dikeyPvc' ? setDikeyPvcExtras : setDikeyStorExtras;

  return (
    <>
      <div className="settings-card">
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <h4>Motor Ayarları ({tabLabel})</h4>
        </div>
        <div className="settings-grid settings-grid-motor">
          <MotorCurrencySelect
            value={extras.motorCurrency}
            onChange={(e) => setExtras(p => ({ ...p, motorCurrency: e.target.value }))}
          />
          <div className="form-group">
            <label>Motor Ücreti</label>
            <input type="number" value={extras.motorPrice} onChange={(e) => setExtras(p => ({ ...p, motorPrice: e.target.value }))} />
          </div>
        </div>
      </div>

      {isPerde && (
        <div className="settings-card settings-card-expandable">
          <div
            className="settings-header clickable"
            onClick={() => setIsFonListCollapsed(!isFonListCollapsed)}
          >
            <div className="settings-title">
              <i className="fas fa-arrows-alt-v"></i>
              <span>Dikey Perde Fon Ayarları</span>
            </div>
            <i className={`fas fa-chevron-${isFonListCollapsed ? 'down' : 'up'}`}></i>
          </div>

          {!isFonListCollapsed && (
            <div className="settings-content settings-content-padded">
              <div className="settings-grid settings-grid-highlight">
                <div className="form-group form-group-wide">
                  <label>
                    <i className="fas fa-coins" aria-hidden="true" />
                    Dikey Perde Fon Ücreti (m²)
                  </label>
                  <input
                    type="number"
                    value={dikeyExtras.fon}
                    onChange={(e) => setDikeyExtras(p => ({ ...p, fon: e.target.value }))}
                  />
                </div>
              </div>

              <div className="settings-list-section">
                <h5 className="settings-list-title">
                  <i className="fas fa-list" aria-hidden="true" />
                  Fon İsimleri Listesi
                </h5>
                <div className="list-add-form">
                  <input
                    type="text"
                    placeholder="Yeni Fon Adı (Örn: Fon 1)"
                    value={newDikeyFonName}
                    onChange={(e) => setNewDikeyFonName(e.target.value)}
                  />
                  <button
                    type="button"
                    className="btn-list-add"
                    onClick={() => {
                      if (!newDikeyFonName) return;
                      const newList = [...(dikeyExtras.fonList || []), newDikeyFonName];
                      setDikeyExtras({ ...dikeyExtras, fonList: newList });
                      setNewDikeyFonName('');
                      handleSaveSettings({ dikeyFonList: newList });
                    }}
                  >
                    <i className="fas fa-plus" aria-hidden="true" />
                  </button>
                </div>

                <div className="settings-list-container">
                  {(!dikeyExtras.fonList || dikeyExtras.fonList.length === 0) ? (
                    <div className="settings-list-empty">Liste boş</div>
                  ) : (
                    <ul className="settings-list">
                      {dikeyExtras.fonList.map((item, index) => (
                        <li key={index} className="settings-list-item">
                          {editingDikeyFonName.index === index ? (
                            <div className="settings-list-edit">
                              <input
                                type="text"
                                value={editingDikeyFonName.value}
                                onChange={(e) => setEditingDikeyFonName({ ...editingDikeyFonName, value: e.target.value })}
                                autoFocus
                              />
                              <button
                                type="button"
                                className="btn-icon btn-icon-success"
                                onClick={() => {
                                  const newList = [...dikeyExtras.fonList];
                                  newList[index] = editingDikeyFonName.value;
                                  setDikeyExtras({ ...dikeyExtras, fonList: newList });
                                  handleSaveSettings({ dikeyFonList: newList });
                                  setEditingDikeyFonName({ index: null, value: '' });
                                }}
                              >
                                <i className="fas fa-check" aria-hidden="true" />
                              </button>
                              <button
                                type="button"
                                className="btn-icon btn-icon-danger"
                                onClick={() => setEditingDikeyFonName({ index: null, value: '' })}
                              >
                                <i className="fas fa-times" aria-hidden="true" />
                              </button>
                            </div>
                          ) : (
                            <>
                              <span className="settings-list-label">{item}</span>
                              <div className="settings-list-actions">
                                <button
                                  type="button"
                                  className="btn-icon"
                                  onClick={() => setEditingDikeyFonName({ index, value: item })}
                                >
                                  <i className="fas fa-edit" aria-hidden="true" />
                                </button>
                                <button
                                  type="button"
                                  className="btn-icon btn-icon-danger"
                                  onClick={() => {
                                    const newList = dikeyExtras.fonList.filter((_, i) => i !== index);
                                    setDikeyExtras({ ...dikeyExtras, fonList: newList });
                                    handleSaveSettings({ dikeyFonList: newList });
                                  }}
                                >
                                  <i className="fas fa-trash-alt" aria-hidden="true" />
                                </button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
});

export default DikeySettings;
